export const VALIDATION_PENDING = 'VALIDATION_PENDING'
export const VALIDATED = 'VALIDATED'
export const LOCKED = 'LOCKED'




// WEBPACK FOOTER //
// ./src/lib/enums/user/status.js